import React from 'react';
import { Box, Drawer, IconButton, useMediaQuery } from '@mui/material';
import { HeaderMenu, UserMenu } from '../types';
import HeaderMainMenu from './HeaderMainMenu';
import HeaderUserMenu from './HeaderUserMenu';
import HeaderNotificationsMenu from './HeaderNotificationsMenu';
import MenuIcon from '@mui/icons-material/Menu';
import { DefaultTheme } from '@mui/styles';

const MENU: HeaderMenu = [
	{
		path: '/',
		label: 'Home',
	},
	{
		submenu: {
			buttonText: 'Links',
			menu: [
				{
					path: '/topics',
					label: 'Topics',
				},
				{
					path: '/interviews',
					label: 'Interviews',
				},
			],
		},
	},
	{
		path: '/admin/users',
		label: 'Users',
	},
	{
		path: '/admin/providers',
		label: 'Solution Providers',
	},
	{
		path: '/admin/terms',
		label: 'Terms',
	},
	{
		path: '/admin/import',
		label: 'Import',
	},
	{
		path: '/admin/export',
		label: 'Export',
	},
];

const USER_MENU: UserMenu = [
	{
		path: '/profile',
		label: 'Profile',
	},
	{
		path: '/metrics',
		label: 'Metrics',
	},
	{
		path: '/messenger',
		label: 'Messenger',
	},
	{
		path: '/invitations',
		label: 'Invite',
	},
	{
		path: '/logout',
		label: 'Sign Out',
	},
];

export default function AdminMenu() {
	const isMobile = useMediaQuery((theme: DefaultTheme) => theme.breakpoints.down('md'));
	const [open, setOpen] = React.useState(false);

	return (
		<>
			{!isMobile && (
				<Box>
					<HeaderMainMenu items={MENU} />
				</Box>
			)}
			<Box mx={isMobile ? 0 : 1}>
				<HeaderNotificationsMenu />
			</Box>
			{!isMobile && (
				<Box>
					<HeaderUserMenu items={USER_MENU} />
				</Box>
			)}
			{isMobile && (
				<>
					<IconButton onClick={() => setOpen(true)}>
						<MenuIcon />
					</IconButton>
					<Drawer anchor="left" open={open} onClose={() => setOpen(false)}>
						<HeaderMainMenu items={MENU} />
					</Drawer>
				</>
			)}
		</>
	);
}
